(() => {
  if (window.__yurchakCompleteLookHomepageAssetReady) {
    window.YurchakCompleteLookInit?.();
    return;
  }
  window.__yurchakCompleteLookHomepageAssetReady = true;

const initPrimary = (root) => {
    if (!root || root.dataset.yclInitialized === 'true') {
      return;
    }

    root.dataset.yclInitialized = 'true';

    const groupTabs = Array.from(root.querySelectorAll('[data-group-tab]'));
    const allSlides = Array.from(root.querySelectorAll('[data-outfit-slide]'));

    if (!allSlides.length) {
      return;
    }

    const autoplay = root.dataset.autoplay === 'true';
    const delay = Number(root.dataset.delay) || 20000;
    const pauseOnHover = root.dataset.pauseHover === 'true';
    const videoAutoplay = root.dataset.videoAutoplay === 'true';
    const designMode = root.dataset.designMode === 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let activeGroup =
      groupTabs.find((tab) => tab.classList.contains('is-active'))?.dataset.groupTab ||
      allSlides[0].dataset.lookGroup;

    const indexes = {
      look_1: 0,
      look_2: 0
    };

    let timer = null;
    let paused = false;

    const getSlides = (group) =>
      allSlides.filter((slide) => slide.dataset.lookGroup === group);

    const stopTimer = () => {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    };

    const pauseAllVideos = () => {
      allSlides.forEach((slide) => {
        slide.querySelectorAll('video').forEach((video) => {
          try {
            video.pause();
          } catch (error) {}
        });
      });
    };

    const playActiveVideo = (slide) => {
      if (!videoAutoplay || !slide) {
        return;
      }

      const video = slide.querySelector('video');

      if (!video) {
        return;
      }

      video.muted = true;

      const promise = video.play();

      if (promise && typeof promise.catch === 'function') {
        promise.catch(() => {});
      }
    };

    const updateGroupTabs = () => {
      groupTabs.forEach((tab) => {
        const active = tab.dataset.groupTab === activeGroup;

        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    const updateSlideArrows = (slide, total) => {
      if (!slide) {
        return;
      }

      slide.querySelectorAll('[data-outfit-prev], [data-outfit-next]').forEach((button) => {
        button.hidden = total <= 1;
      });
    };

    const startTimer = () => {
      stopTimer();

      if (
        !autoplay ||
        reduceMotion ||
        paused ||
        document.hidden ||
        getSlides(activeGroup).length < 2
      ) {
        return;
      }

      timer = window.setTimeout(() => {
        showSlide(activeGroup, indexes[activeGroup] + 1, false);
        startTimer();
      }, delay);
    };

    const showSlide = (group, requestedIndex, restartTimer = true) => {
      const slides = getSlides(group);

      if (!slides.length) {
        return;
      }

      activeGroup = group;

      let index = requestedIndex;

      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }

      indexes[group] = index;

      pauseAllVideos();

      allSlides.forEach((slide) => {
        slide.hidden = true;
        slide.classList.remove('is-active', 'is-entering');
      });

      const activeSlide = slides[index];

      activeSlide.hidden = false;
      activeSlide.classList.add('is-active');

      if (!reduceMotion) {
        void activeSlide.offsetWidth;
        activeSlide.classList.add('is-entering');
      }

      const productSlider = activeSlide.querySelector('[data-product-slider]');

      if (productSlider) {
        productSlider.scrollTop = 0;
        productSlider.scrollLeft = 0;
        window.requestAnimationFrame(() => {
          activeSlide.querySelector('.ycl-product-scroll-shell')?._updateScrollButtons?.();
        });
      }

      updateGroupTabs();
      updateSlideArrows(activeSlide, slides.length);
      playActiveVideo(activeSlide);

      if (restartTimer) {
        startTimer();
      }
    };

    groupTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const group = tab.dataset.groupTab;
        showSlide(group, indexes[group] || 0, true);
      });
    });

    const updateModalAddState = (modal) => {
      if (!modal) return;
      const addButton = modal.querySelector('[data-add-set]');
      const items = Array.from(modal.querySelectorAll('[data-set-item]'));

      if (!addButton || !items.length) return;

      const ready = items.every((item) => {
        if (item.dataset.productAvailable === 'false') return false;
        const selected = item.querySelector('[data-selected-variant]');
        return Boolean(selected?.value);
      });

      addButton.disabled = !ready;
      addButton.setAttribute('aria-disabled', ready ? 'false' : 'true');
    };

    root.addEventListener('click', (event) => {
      const previousButton = event.target.closest('[data-outfit-prev]');
      const nextButton = event.target.closest('[data-outfit-next]');

      if (previousButton) {
        event.preventDefault();
        showSlide(activeGroup, indexes[activeGroup] - 1, true);
        return;
      }

      if (nextButton) {
        event.preventDefault();
        showSlide(activeGroup, indexes[activeGroup] + 1, true);
        return;
      }

      const openSetButton = event.target.closest('[data-open-set-modal]');

      if (openSetButton) {
        event.preventDefault();

        const modalId = openSetButton.dataset.openSetModal;
        root.querySelectorAll('[data-set-modal]').forEach((existing) => {
          if (existing.dataset.setModal !== modalId) existing.remove();
        });
        let modal = root.querySelector(`[data-set-modal="${modalId}"]`);

        if (!modal) {
          const template = root.querySelector(`[data-set-modal-template="${modalId}"]`);
          const host = root.querySelector('.ycl-modals');
          if (template instanceof HTMLTemplateElement && host) {
            host.appendChild(template.content.cloneNode(true));
            modal = root.querySelector(`[data-set-modal="${modalId}"]`);
          }
        }

        if (modal) {
          modal.hidden = false;
          modal.dataset.returnFocusId = openSetButton.id || '';
          modal._returnFocus = openSetButton;
          document.body.classList.add('ycl-modal-open');
          paused = true;
          stopTimer();

          updateModalAddState(modal);

          const firstFocusable =
            modal.querySelector('[data-variant-choice]:not(:disabled)') ||
            modal.querySelector('[data-close-set-modal]') ||
            modal.querySelector('button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled)');
          window.setTimeout(() => firstFocusable?.focus(), 0);
        }

        return;
      }

      const closeSetButton = event.target.closest('[data-close-set-modal]');

      if (closeSetButton) {
        const modal = closeSetButton.closest('[data-set-modal]');

        if (modal) {
          const returnFocus = modal._returnFocus;
          document.body.classList.remove('ycl-modal-open');
          modal.remove();
          returnFocus?.focus?.();
          paused = false;
          startTimer();
        }

        return;
      }

      const variantChoice = event.target.closest('[data-variant-choice]');

      if (variantChoice) {
        event.preventDefault();

        if (variantChoice.disabled || !variantChoice.dataset.variantId) {
          return;
        }

        const item = variantChoice.closest('[data-set-item]');
        const selectedVariant = item?.querySelector('[data-selected-variant]');
        const error = item?.querySelector('[data-variant-error]');

        item?.querySelectorAll('[data-variant-choice]').forEach((choice) => {
          const selected = choice === variantChoice;
          choice.classList.toggle('is-selected', selected);
          choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        if (selectedVariant) {
          selectedVariant.value = variantChoice.dataset.variantId;
        }

        item?.classList.remove('has-error');
        if (error) error.hidden = true;
        updateModalAddState(item?.closest('[data-set-modal]'));

        return;
      }

      const addSetButton = event.target.closest('[data-add-set]');

      if (addSetButton) {
        const modal = addSetButton.closest('[data-set-modal]');

        if (!modal) {
          return;
        }

        const items = [];
        let firstInvalid = null;
        let hasInvalid = false;

        modal.querySelectorAll('[data-set-item]').forEach((item) => {
          item.classList.remove('has-error');

          const error = item.querySelector('[data-variant-error]');
          const selectedVariant = item.querySelector('[data-selected-variant]');
          const firstChoice = item.querySelector('[data-variant-choice]:not(:disabled)');

          if (error) {
            error.hidden = true;
          }

          if (!selectedVariant?.value) {
            hasInvalid = true;
            item.classList.add('has-error');

            if (error) {
              error.hidden = false;
              error.textContent = firstChoice
                ? 'Choose an available option.'
                : 'This item is currently sold out.';
            }

            if (!firstInvalid && firstChoice) {
              firstInvalid = firstChoice;
            }

            return;
          }

          items.push({
            id: Number(selectedVariant.value),
            quantity: 1
          });
        });

        if (hasInvalid) {
          firstInvalid?.focus();
          const modalError = modal.querySelector('[data-set-error]');
          if (modalError) {
            modalError.textContent = firstInvalid
              ? 'Please choose an available option for every item.'
              : 'One or more items in this set are currently sold out.';
            modalError.hidden = false;
          }
          updateModalAddState(modal);
          return;
        }

        if (!items.length) {
          return;
        }

        const modalError = modal.querySelector('[data-set-error]');

        if (modalError) {
          modalError.hidden = true;
          modalError.textContent = '';
        }

        addSetButton.disabled = true;
        addSetButton.textContent = 'ADDING…';

        const addPromise = window.YurchakCompleteLookCore?.addSet
          ? window.YurchakCompleteLookCore.addSet(items, {
              source: 'yurchak-complete-look',
              title: items.length > 1 ? 'Complete the look added' : 'Item added'
            })
          : Promise.reject(new Error('Complete Look cart engine is unavailable.'));

        addPromise
          .then(() => {
            window.location.href = window.Shopify.routes.root + 'cart';
          })
          .catch((error) => {
            if (modalError) {
              modalError.textContent = error.message || 'Could not add the set.';
              modalError.hidden = false;
            }

            addSetButton.disabled = false;
            addSetButton.textContent = 'ADD SET TO BAG';
          });

        return;
      }

    });


    document.addEventListener('keydown', (event) => {
      const openModal = root.querySelector('[data-set-modal]:not([hidden])');

      if (openModal && event.key === 'Tab') {
        const focusable = Array.from(
          openModal.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])')
        ).filter(node => !node.hidden && node.getClientRects().length);

        if (focusable.length) {
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }

      if (event.key !== 'Escape') {
        return;
      }

      if (openModal) {
        const returnFocus = openModal._returnFocus;
        document.body.classList.remove('ycl-modal-open');
        openModal.remove();
        returnFocus?.focus?.();
        paused = false;
        startTimer();
      }
    });

    if (pauseOnHover) {
      root.addEventListener('mouseenter', () => {
        paused = true;
        stopTimer();
      });

      root.addEventListener('mouseleave', () => {
        paused = false;
        startTimer();
      });
    }

    root.querySelectorAll('[data-product-slider]').forEach((slider) => {
      slider.addEventListener(
        'touchstart',
        () => {
          paused = true;
          stopTimer();
        },
        { passive: true }
      );

      slider.addEventListener(
        'touchend',
        () => {
          paused = false;
          startTimer();
        },
        { passive: true }
      );
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopTimer();
        pauseAllVideos();
      } else {
        const slides = getSlides(activeGroup);
        playActiveVideo(slides[indexes[activeGroup]]);
        startTimer();
      }
    });

    root.addEventListener('shopify:block:select', (event) => {
      const blockId = event.detail && event.detail.blockId ? event.detail.blockId : null;

      if (!blockId) {
        return;
      }

      const selectedSlide = allSlides.find((slide) => slide.dataset.outfitId === blockId);

      if (!selectedSlide) {
        return;
      }

      const group = selectedSlide.dataset.lookGroup;
      const slides = getSlides(group);
      const index = slides.indexOf(selectedSlide);

      paused = true;
      stopTimer();
      showSlide(group, index >= 0 ? index : 0, false);
    });

    root.addEventListener('shopify:block:deselect', () => {
      paused = false;
      startTimer();
    });

    showSlide(activeGroup, indexes[activeGroup] || 0, false);
    startTimer();
};

const initVertical = (root) => {
  if (!root || root.dataset.verticalProductScrollReady === 'true') return;
  root.dataset.verticalProductScrollReady = 'true';

  const desktopQuery = window.matchMedia('(min-width: 990px)');

  const setup = (shell) => {
    const slider = shell.querySelector('[data-product-slider]');
    const up = shell.querySelector('[data-product-scroll="up"]');
    const down = shell.querySelector('[data-product-scroll="down"]');
    if (!slider || !up || !down) return;

    const step = () => {
      const card = slider.querySelector('.ycl-product');
      if (!card) return Math.max(1, slider.clientHeight / 2);
      const styles = getComputedStyle(slider);
      const gap = parseFloat(styles.rowGap || styles.gap || 0) || 0;
      return card.getBoundingClientRect().height + gap;
    };

    const update = () => {
      if (!desktopQuery.matches) {
        slider.scrollTop = 0;
        up.disabled = true;
        down.disabled = true;
        return;
      }
      const max = Math.max(0, slider.scrollHeight - slider.clientHeight);
      up.disabled = max <= 2 || slider.scrollTop <= 2;
      down.disabled = max <= 2 || slider.scrollTop >= max - 2;
    };

    up.addEventListener('click', () => {
      slider.scrollBy({ top: -step(), behavior: 'smooth' });
    });

    down.addEventListener('click', () => {
      slider.scrollBy({ top: step(), behavior: 'smooth' });
    });

    shell._updateScrollButtons = update;
    slider.addEventListener('scroll', () => requestAnimationFrame(update), { passive:true });
    window.addEventListener('resize', () => requestAnimationFrame(update), { passive:true });
    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', () => requestAnimationFrame(update));
    }

    update();
    requestAnimationFrame(update);
    setTimeout(update, 120);
  };

  root.querySelectorAll('.ycl-product-scroll-shell').forEach(setup);
};

  const initRoot = root => {
    initPrimary(root);
    initVertical(root);
  };

  const initAll = (scope = document) => {
    const roots = [];
    if (scope?.matches?.('[data-ycl-section]')) roots.push(scope);
    scope?.querySelectorAll?.('[data-ycl-section]').forEach(root => roots.push(root));
    roots.forEach(initRoot);
  };

  window.YurchakCompleteLookInit = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
